import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BlogPost } from "../../../typings/blogs";

interface BlogsState {
  loading: boolean;
  blogs: BlogPost[];
  blog: BlogPost[];
  error: string | null;
}

const initialState: BlogsState = {
  loading: false,
  blogs: [],
  blog: [],
  error: null,
};

const blogsSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    fetchBlogs(state) {
      state.loading = true;
      state.error = null;
    },
    fetchBlogsSuccess(state, action: PayloadAction<BlogPost[]>) {
      state.loading = false;
      state.blogs = action.payload;
      state.error = null;
    },
    fetchBlogsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    fetchBlog(state) {
      state.loading = true;
      state.error = null;
    },
    fetchBlogSuccess(state, action: PayloadAction<BlogPost[]>) {
      state.loading = false;
      state.blog = action.payload;
      state.error = null;
    },
    fetchBlogFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchBlogs,
  fetchBlogsSuccess,
  fetchBlogsFailure,
  fetchBlog,
  fetchBlogFailure,
  fetchBlogSuccess,
} = blogsSlice.actions;

export default blogsSlice.reducer;
